import i18next from 'i18next';

i18next.addResources('es_CL', 'SliderNumber', {
  notProbably: 'Nada probable',
  probably: 'Muy probable',
  tooBad: 'Muy malo',
  tooGood: 'Muy bueno'
});
